export default "__VITE_ASSET__BW3oYY6k__"